import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-open-path-redirect',
  template: ''
})
export class OpenPathRedirectComponent implements OnInit {
  ngOnInit(): void {
    try {
      const host = (window.location && window.location.hostname) || '';
      const hostLower = host.toLowerCase();
      const isGreen = hostLower === 'customerportal.green.thig.com';
      const isOrange = hostLower === 'customerportal.orange.thig.com';
      const ua = navigator.userAgent || '';
      const isAndroid = /android/i.test(ua);
      const isIOS = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream;

      if (isAndroid) {
        const pkg = isOrange ? 'com.towerhill.dev.mobileapp'
                             : (isGreen ? 'com.towerhill.test.mobileapp' : 'com.towerhill.prod.mobileapp');
        const url = new URL('https://play.google.com/store/apps/details');
        url.searchParams.set('id', pkg);
        window.location.replace(url.toString());
        return;
      }

      if (isIOS) {
        if (isGreen || isOrange) {
          try { window.location.replace('itms-beta://testflight.apple.com'); return; } catch (e) {}
          window.location.replace('https://testflight.apple.com');
          return;
        }
        try { window.location.replace('itms-apps://itunes.apple.com/app/id6744824769'); return; } catch (e) {}
        window.location.replace('https://apps.apple.com/app/id6744824769');
        return;
      }
    } catch (_) {
      // no-op
    }
  }
}
